import React, { useState } from 'react';
import styles from './verification-bottomsheet.module.scss';
import { BottomSheet, Button, Typography } from '@/ui-kit';
import { OkHandIcon, VerificationIcon } from '@/assets/icons';
import { useAuth } from '@/store/useAuth';
import WebApp from '@twa-dev/sdk';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
    isVerificationModalOpen: boolean;
    setIsVerificationModalOpen: (val: boolean) => void;
    onOkClicked?: () => Promise<boolean>;
}

export const VerificationBottomsheet: React.FC<Props> = ({
    isVerificationModalOpen,
    setIsVerificationModalOpen,
    onOkClicked,
}) => {
    const userData =
        useAuth((state) => state.getUser());

    const { t } = useTranslation();

    const handleBtnClick = async () => {
        if (onOkClicked) {
            const isSuccess = await onOkClicked?.()
            if (!isSuccess) return
        }
        const { id, public_name } = userData ?? {};
        const params = new URLSearchParams({
            text: t('verification_msg', { name: public_name, id })
        });

        WebApp.openTelegramLink(`https://t.me/euphora_support?${params}`);

        setIsVerificationModalOpen(false)
    }
    
    return (
        <BottomSheet
            isOpen={isVerificationModalOpen}
            isDeskorTop={false}
            onClose={() => setIsVerificationModalOpen(false)}>
            <div className={styles.verificationModalContent}>
                <VerificationIcon className={styles.verificationModalContentIcon} />
                <div className={styles.verificationModalContentHeader}>
                    <Typography
                        className={styles.verificationModalContentHeaderTitle}
                        variant={'h5'}
                        fontWeight={'bold'}>
                        <Trans i18nKey="verification_note" />
                    </Typography>
                    <Typography className={styles.verificationModalContentHeaderDesc}>
                        <Trans i18nKey="verification_action" />
                    </Typography>
                    <OkHandIcon width={40} height={40} />
                </div>
                <div className={styles.verificationModalContentFootnote}>
                    <Typography className={styles.verificationModalContentFootnoteTitle}>
                        {t('verification_desc_secondary')}
                    </Typography>
                    <Typography className={styles.verificationModalContentFootnoteSubtitle}>
                        {t('video_not_shared')}
                    </Typography>
                    <Button
                        typeColor="orange"
                        className={styles.verificationModalContentFootnoteBtn}
                        onClick={handleBtnClick}>
                        {t('ok')}
                    </Button>
                </div>
            </div>
        </BottomSheet>
    );
};
